import {Component, HostBinding, Input} from '@angular/core';
import {isNullOrUndefined} from 'util';

const selectorName = 'cat-form-state-info';
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: selectorName,
  templateUrl: './form-state-info.component.html',
})
export class FormStateInfoComponent {
  @HostBinding('class') classNames = defaultClassNames;
  @Input()
  set form(value: any) {
    if (!isNullOrUndefined(value)) {
      this.classNames = [defaultClassNames, 'hide'].join(' ');
    } else {
      this.classNames = defaultClassNames;
    }
  }

  constructor() {
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/ui-base/components/form-state-info/form-state-info.component.ts